import { useState, useEffect, useCallback } from 'react';
import { api, handleApiError } from './api';
import { ApiResponse } from '@ouagaliv/shared';

export function useFetch<T>(url: string) {
  const [data, setData] = useState<T | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');

  const refetch = useCallback(async () => {
    setIsLoading(true);
    setError('');
    try {
      const res = await api.get<ApiResponse<T>>(url);
      if (!res.data.success) {
        setError(res.data.error?.message || 'Chargement impossible');
      } else if (res.data.data !== undefined) {
        setData(res.data.data);
      } else {
        setError('Chargement impossible');
      }
    } catch (err) {
      setError(handleApiError(err));
    } finally {
      setIsLoading(false);
    }
  }, [url]);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return { data, isLoading, error, refetch };
}
